mainApp.component('generalProperties', {
    templateUrl: '/public/directives/generalProperties.html',
    bindings: {
        properties: '=',
        deleteProperties: '&',
        generalPropertiesChanged: '&',
        levelObject: '@',
        elementId: '='
    },
    controller: generalPropertiesController
});

function generalPropertiesController($scope, GeneralPropertiesService, GeneralUtilsService, $timeout, $state){
    var $ctrl = this;
    $scope.origGeneralProperties = [];

    $ctrl.$onInit = function(){
        $ctrl.propertiesModified = false;
    }

    //update ng-table with the new received properties
    $scope.$on('reset-properties', function(event){
        event.currentScope.$ctrl.propertiesModified = new Date().getTime();
    });

    function getFields(){
            var templateStr =
               "<div ng-class=\"(item.isParentValue != null && !item.enabled) ? 'cato-tooltip no-disable' : ''\" data-title='This feature {{item.isParentValue ? \"uses the value as defined in Global Settings > Advanced Configuration\": \"is disabled and uses the default\"}} value'>" +
                   '<div style="width: 115px;">' +
                       '<div ng-if="item.fieldType" ng-switch="item.fieldType">' +
                           '<span ng-switch-when="STRING">' +
                               '<input ng-if="item.enabled" type="text" class="form-control ellipsis" ng-model="item.value"/>' +
                              '<input ng-if="!item.enabled" type="text" class="disable-event form-control ellipsis" ng-model="item.parentValue"/>' +
                           '</span>' +
                           '<span ng-switch-when="PASSWORD">' +
                              '<input ng-if="item.enabled" type="password" class="form-control ellipsis" ng-model="item.value" autocomplete="off"/>' +
                             '<input ng-if="!item.enabled" type="password" class="disable-event form-control ellipsis" ng-model="item.parentValue" autocomplete="off"/>' +
                           '</span>' +
                           '<span ng-switch-when="IP">' +
                               '<input ng-if="item.enabled" type="text" class="form-control ellipsis" ng-model="item.valueIP"/>' +
                              '<input ng-if="!item.enabled" type="text" class="disable-event form-control ellipsis" ng-model="item.parentValueIP"/>' +
                           '</span>' +
                           '<span ng-switch-when="NUMBER">' +
                               '<input ng-if="item.enabled" type="number" class="form-control" ng-model="item.valueLong"/>' + //max={{item.maxNumber}} min={{item.minNumber}}
                              '<input ng-if="!item.enabled" type="number" class="disable-event form-control" ng-model="item.parentValueLong"/>' +
                           '</span>' +
                           '<span ng-switch-when="BOOLEAN">' +
                               '<div ng-if="item.enabled" class="radio">' +
                                  '<label><input type="radio" ng-value="true" ng-model="item.valueBoolean"/>On</label>' +
                                  '<label><input type="radio" ng-value="false" ng-model="item.valueBoolean"/>Off</label>' +
                               '</div>' +
                               '<div ng-if="!item.enabled" class="disable-event radio">' +
                                  '<label><input type="radio" ng-value="true" ng-model="item.parentValueBoolean"/>On</label>' +
                                  '<label><input type="radio" ng-value="false" ng-model="item.parentValueBoolean"/>Off</label>' +
                               '</div>' +
                           '</span>' +
                           '<span ng-switch-when="SELECTION">' +
                               '<select ng-if="item.enabled" class="generalPropertiesSelect" ng-model="item.value">'+
                                   '<option ng-repeat="selectItem in item.selectOptions" value="{{selectItem.value}}">{{selectItem.display}}</option>' +
                               '</select>' +
                               '<select ng-if="!item.enabled" class="disable-event generalPropertiesSelect" ng-model="item.parentValue">' +
                                   '<option ng-repeat="selectItem in item.selectOptions" value="{{selectItem.value}}">{{selectItem.display}}</option>' +
                               '</select>' +
                           '</span>' +
                       '</div>' +
                       '<div class="ellipsis" ng-if="!item.fieldType">' +
                           '<spans>' +
                               '<input ng-if="item.enabled" type="text" class="form-control ellipsis" ng-model="item.value"/>' +
                              '<input ng-if="!item.enabled" type="text" class="disable-event form-control ellipsis" ng-model="item.parentValue"/>' +
                           '</span>' +
                       '</div>' +
                   '</div>' +
               '</div>';

            var fields = [
                { label: 'Name', path: 'displayName', template:
                    '<div ng-if="item.userType==\'USER\'" class="ellipsis no-disable keyWidth"><span ng-change="tableConfig.displayNameChanged(item)" ng-model="item.displayName" class="ellipsis">{{item.displayName}}</span></div>' +
                    '<div ng-if="item.userType!=\'USER\'" class="ellipsis keyWidth"><input type="text" class="form-control ellipsis keyWidth" ng-change="tableConfig.displayNameChanged(item)" ng-model="item.displayName"/></div>'
                },
                { label: 'Description', path: 'description', template: '<div class="no-disable ellipsis descriptionWidth"><span>{{item.description}}</span></div>' },
                { label: 'Value', path: 'value', template: templateStr },
                { label: 'Comment', path: 'propertyComment', template: '<div class="ellipsis commentWidth"><span><input ng-if="item.enabled" type="text" class="form-control ellipsis" ng-model="item.propertyComment"/><input ng-if="!item.enabled" type="text" class="form-control" ng-model="item.parentValuePropertyComment"/></span></div>' },
                { label: 'Last Modified', path: 'lastModified', template: '<span ng-if="item.enabled"><time>{{item.lastModified | date:"medium"}}</time></br>{{item.userEmail}}</span><span ng-if="!item.enabled"><time ng-if="item.parentValueLastModified!=0">{{item.parentValueLastModified | date:"medium"}}</time></br>{{item.parentValueUserEmail}}</span>' },
                { label: 'Status', path: 'enabled', template:
                    "<div ng-class=\"(item.isPropertySupported != null && !item.isPropertySupported && !item.enabled && item.type=='SITEGENERALPROPERTY' ? 'cato-tooltip no-disable' : '')\" data-title='This feature is only supported with socket version {{item.requiredVersion}} and higher. Please contact support to upgrade the socket.'>" +
                        "<input type='checkbox' ng-class=\"(item.isPropertySupported != null && !item.isPropertySupported ? 'disable-event' : 'no-disable')\" id='rules-enabled-toggle_{{item.id}}' ng-model='item.enabled' chked='item.enabled' chx-toggle/>" +
                    '<div>'
                }
            ];

            if (isSystemLogin){
                fields.push({ label: 'User', path: 'userType', template: '<div style="min-width:36px;"><span><svg class="icon icon-{{item.userType.toLowerCase()}}"><use xlink:href="" ng-href="/public/images/icons/main.svg#icon-{{item.userType.toLowerCase()}}"></use></svg></span></div>' });
            }

            return fields;
    }

    function getSpecialActions(){
        if (isSystemLogin){
            return [{
                func: function (selectedItems) {
                    var defaultsKeys = [];
                    selectedItems.forEach(function (item) {
                        if (item.userType == "USER")
                            defaultsKeys.push(item.displayName);
                    });
                    if (defaultsKeys.length > 0){
                        $scope.$root.alert('Unselect the following settings' + (defaultsKeys.length > 0 ? "s" : "") + ' before saving: ' + defaultsKeys.join(', '));
                        return;
                    }

                    var deletedGeneralProperties = [];
                    selectedItems.forEach(function (item) {
                        for (var i = 0; i < $scope.generalProperties.length; i++) {
                            var generalProperty = $scope.generalProperties[i];
                            if (generalProperty.id === item.id) {
                                $scope.generalProperties.splice(i, 1);
                                if (item.id > 0) {
                                    deletedGeneralProperties.push(item);
                                }
                                break;
                            }
                        }
                    });

                    $ctrl.generalPropertiesTableConfig.refreshViewItems = new Date().getTime();
                    $ctrl.deleteProperties({properties : deletedGeneralProperties});
                },
                icon: 'delete',
                tooltip: 'Delete',
            }];
        }

        return [];
    }

    function addActionFunc() {
        if (!$scope.generalProperties) {
            $scope.generalProperties = [];
        }
        $scope.generalProperties.push({ id: GeneralUtilsService.getRandomId(), name: '', value: '' ,fieldType: "STRING", userType: "ADMIN", enabled: true, displayName: ' '});
        $ctrl.generalPropertiesTableConfig.refreshViewItems = new Date().getTime();
    }

    function getAddAction(){
        if (isSystemLogin){
            return addActionFunc;
        }

        return null;
    }

    function getCheckboxStatus(){
        return isSystemLogin ? false : true;
    }

    function getActions(){
        if (isSystemLogin){
            return [];
        }

        return;
    }

    $scope.$on('$toggleClicked', function (event, id, checked) {
        var elementId = id.split("_")[1];
        for(var i=0; i < $scope.generalProperties.length; i++){
            var item = $scope.generalProperties[i];
            if (item.id != elementId)
                continue;

            var status = checked ? false : true;
            if (status && (item.value != null || item.valueBoolean != null || item.valueLong != null || item.valueIP != null))
                continue;

            item.enabled = status;
            switch (item.fieldType){
                case "NUMBER":
                    restoreOrStoreValue(status, item, "Long");
                    break;
                case "BOOLEAN":
                    restoreOrStoreValue(status, item, "Boolean");
                    break;
                case "IP":
                    restoreOrStoreValue(status, item, "IP");
                    break;
                case "STRING":
                case "SELECTION":
                    restoreOrStoreValue(status, item, "value");
                    break;
            }

            break;
        }
    });

    /**
     * Store user value to $var to be ignore by the angular.equals function or restore the value to the correct field
     */
    function restoreOrStoreValue(status, item, itemKey){
        if (status){
            if (item.$tempValue){
                item["value" + itemKey] = item.$tempValue;
                item.$tempValue = undefined;

                return;
            }
            item.$tempValue = item["value" + itemKey];
            item["value" + itemKey] = item['parentValue' + itemKey];

            return;
        }

        var tempVar = item["value" + itemKey];
        item["value" + itemKey] = item.$tempValue;
        item.$tempValue = tempVar;
    }

    // deep watch on general-properties and updating the parent when changes are made or restore to default.
    $scope.$watch("generalProperties", function(newVal){
        if (!newVal)
            return;

        if (!angular.equals(newVal, $scope.origGeneralProperties)){
            newVal.forEach(function (item) {
                if (!item.enabled && item.$tempValue != null &&
                    !(item.value != null || item.valueBoolean != null || item.valueLong != null || item.valueIP != null)){
                    switch (item.fieldType){
                        case "NUMBER":
                            item.valueLong = item.$tempValue;
                            break;
                        case "BOOLEAN":
                            item.valueBoolean = item.$tempValue;
                            break;
                        case "IP":
                            item.valueIP = item.$tempValue;
                            break;
                        case "STRING":
                        case "SELECTION":
                            item.value = item.$tempValue;
                            break;
                    }
                }
            });
            $ctrl.generalPropertiesChanged({ properties: newVal, isGeneralPropertiesUpdated: true });
        }else{
            $ctrl.generalPropertiesChanged({ properties: null, isGeneralPropertiesUpdated: false });
        }
    }, true);

    function init(){
        if ($scope.$root && $scope.$root.tags) {
            //ng-table parameters
            $ctrl.generalPropertiesTableConfig = {
                id: "generalProperties",
                displayNameChanged: function(item){
                    if (item.userType == "ADMIN"){
                        item.name = item.displayName;
                    }
                },
                dataURL : function (){
                    if ($ctrl.elementId){
                        var levelObject = $ctrl.levelObject;
                        var elementIdStr = levelObject == "SITE" ? "&siteId=" : levelObject == "ACCESSLOGIN" ? "&accessloginId=" : null;

                        return "/getEnrichedGeneralProperties?accountId=" + $state.params.accountId + "&levelObject=" + levelObject + (elementIdStr != null ? elementIdStr + $ctrl.elementId : "");
                    }
                },
                parseData: function (data) {
                    if (data){
                        GeneralPropertiesService.parsedAndAddTempIdForGeneralPropertiesList(data);
                        $scope.origGeneralProperties = angular.copy(data);
                        $scope.generalProperties = data;

                        return data;
                    }
                },
                titleSearch: 'Configuration',
                selectedItems: [],
                actions: getActions(),
                fields: getFields(),
                addAction: getAddAction(),
                specialActions: getSpecialActions(),
                hideCheckboxes: getCheckboxStatus(),
                clientSideSort: true,
                clientSideSearch: true,
                clientSidePaging: true,
                keepPageOnRefresh: true,
                pageSize: 10,
                sortList: [{sortField: "displayName", sortDir: "ASC" }]
            }
        }else{
            $timeout(function () {
                init();
            }, 10, true);
        }
    }

    init();
}